<script lang="ts">
    // Campo rotulado da folha: o rótulo fica acima, pequeno, e o controle dentro de uma caixa sóbria.
    // Existe porque o Zinput padrão traz a moldura das telas administrativas, com outra densidade.
    let className: string = ''
    export { className as class }
    export let label: string = ''
    export let grow: boolean = true
</script>

<label class="zfield {className}" class:grow>
    {#if label}
        <span class="zfield_label">{label}</span>
    {/if}
    <span class="zfield_control">
        <slot />
    </span>
</label>

<style>
    /* valores base = tema escuro */
    .zfield {
        display: flex;
        flex-direction: column;
        gap: 4px;
        min-width: 0;
    }
    .zfield.grow {
        flex: 1 1 0;
    }
    .zfield_label {
        font-size: 12px;
        opacity: 0.55;
    }
    .zfield_control {
        display: block;
    }
    /* os controles nativos (input date/time, select) usam as mesmas variáveis dos campos do app
       (css_z_field.css): é o que mantém a folha e os formulários com a mesma cara e a mesma altura */
    .zfield_control {
        min-width: 0;
    }
    .zfield_control :global(input),
    .zfield_control :global(select) {
        width: 100%;
        /* o input[type=date] do iPhone escreve a data por extenso ("8 Oct 2026") e, sem isto, não
           encolhe abaixo desse texto: o campo vazava para cima do vizinho. Com min-width zerado e
           a largura contando a borda, o width:100% volta a mandar e o texto é que se ajusta. */
        min-width: 0;
        max-width: 100%;
        box-sizing: border-box;
        /* corta o valor do controle nativo que insistir em desenhar além da caixa, em vez de
           deixá-lo por cima do campo vizinho. Fica no próprio input: o anel de foco é box-shadow,
           desenhado fora da caixa, então não é afetado */
        overflow: hidden;
        background: var(--z-field-bg);
        border: 1px solid var(--z-field-border);
        border-radius: var(--z-field-radius);
        color: inherit;
        font: inherit;
        font-size: 15px;
        padding: 9px 10px;
        min-height: var(--z-field-height);
    }
    .zfield_control :global(input:focus),
    .zfield_control :global(select:focus) {
        outline: none;
        border-color: var(--z-field-focus);
        box-shadow: 0 0 0 3px var(--z-field-focus-ring);
    }
</style>
